import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { tap } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";

interface CacheEntry {
  data: BehaviorSubject<HttpResponse<any>>;
  expiration: number;
}

@Injectable()
export class WSInterceptor implements HttpInterceptor {
  private cache: Map<string, CacheEntry> = new Map();
  // private cacheDuration = 30000; // Duração do cache em milissegundos (30s)
  private cacheDuration = 0; // Duração do cache em milissegundos (30s)
  private cacheSizeLimit = 30; // Limite de tamanho do cache

  constructor(
    private translateService: TranslateService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let browserLang = this.translateService.getBrowserCultureLang();

    let modifiedReq = req.clone({
      setHeaders: {
        'Accept-Language': browserLang,
      },
      withCredentials: true,
    });

    if (req.method === 'DELETE') {
      modifiedReq = modifiedReq.clone({
        body: {},
      });
    }

    if (req.method === 'GET' && req.url.includes('app/posts')) {
      const cacheEntry = this.cache.get(req.urlWithParams);
      const now = Date.now();

      const url = new URL(req.urlWithParams);
      const forceParam = url.searchParams.get('force');

      if (forceParam === 'true') {
        return next.handle(modifiedReq);
      }

      if (cacheEntry && cacheEntry.expiration > now) {
        return cacheEntry.data.asObservable();
      }

      const newCacheEntry: CacheEntry = {
        data: new BehaviorSubject<HttpResponse<any>>(null),
        expiration: now + this.cacheDuration
      };

      this.cache.set(req.urlWithParams, newCacheEntry);

      return next.handle(modifiedReq).pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            newCacheEntry.data.next(event);
            this.ensureCacheSizeLimit();
          }
        })
      );
    }

    return next.handle(modifiedReq);
  }

  private ensureCacheSizeLimit() {
    const now = Date.now();

    // Remove todos elementos já expirados
    for (const [key, entry] of this.cache.entries()) {
      if (entry.expiration <= now) {
        this.cache.delete(key);
      }
    }

    // Se ainda o tamanho do cache for maior que o limite, remove os elementos mais antigos
    while (this.cache.size > this.cacheSizeLimit) {
      const oldestKey = Array.from(this.cache.keys())[0];
      this.cache.delete(oldestKey);
    }
  }
}
